export function encodeBase64(str: string){
  return window.btoa(str);
}

export function decodeBase64(str: string){
  return window.atob(str);
}